import { ChaveValor } from '../chave-valor.model';

export class SecretariasEnum {

  lista: ChaveValor[];

  constructor() {
    this.lista = [

      { id: 1, nome: 'Secretaria de Município de Administração e Gestão de Pessoas' },
      { id: 2, nome: 'Controladoria e Auditoria Geral do Município' },
      { id: 3, nome: 'Secretaria de Município de Cultura' },
      { id: 4, nome: 'Secretaria de Município de Comunicação' },
      { id: 5, nome: 'Secretaria de Município de Desenvolvimento Econômico e Turismo' },
      { id: 6, nome: 'Secretaria de Município de Desenvolvimento Rural' },
      { id: 7, nome: 'Secretaria de Município de Desenvolvimento Social' },
      { id: 8, nome: 'Secretaria de Município da Educação' },
      { id: 9, nome: 'Secretaria de Município de Esporte e Lazer' },
      { id: 10, nome: 'Secretaria de Município de Elaboração de Projetos e Captação de Recursos' },
      { id: 11, nome: 'Secretaria de Município de Finanças' },
      { id: 12, nome: 'Gabinete do Prefeito' },
      { id: 13, nome: 'Secretaria de Município de Habitação e Regularização Fundiária' },
      { id: 14, nome: 'Secretaria de Município de Infraestrutura e Serviços Públicos' },
      { id: 15, nome: 'Secretaria de Município de Inovação e Tecnologia da Informação' },
      { id: 16, nome: 'Secretaria de Licenciamento e Desburocratização' },
      { id: 17, nome: 'Secretaria de Município de Meio Ambiente' },
      { id: 18, nome: 'Secretaria de Município de Mobilidade Urbana' },
      { id: 19, nome: 'Procuradoria Geral do Município' },
      { id: 20, nome: 'Secretaria de Município da Saúde' },
      { id: 21, nome: 'Instituto de Planejamento de Santa Maria' },
      { id: 22, nome: 'Instituto de Previdência e Assistência à Saúde dos Servidores Públicos Municipais de Santa Maria' }
    ];
  }
}
